import { create } from "zustand";

interface TaskMultiSelectionStore {
  selectedTasks: Map<string, "active" | "inactive">;
  actions: {
    addTaskToSelection: (taskId: string, state: "active" | "inactive") => void;
    removeTaskFromSelection: (taskId: string) => void;
    clearSelection: () => void;
    // getDistribution: () => {
    //   hasActiveTasks: boolean;
    //   hasInactiveTasks: boolean;
    // };
  };
}

const useTaskMultiSelectionStore = create<TaskMultiSelectionStore>((set) => ({
  selectedTasks: new Map(),
  actions: {
    addTaskToSelection: (taskId, status) =>
      set((state) => ({
        selectedTasks: new Map(state.selectedTasks).set(taskId, status), // Create a new Set
      })),
    removeTaskFromSelection: (taskId) =>
      set((state) => {
        const updatedMap = new Map(state.selectedTasks);
        updatedMap.delete(taskId); // Create a new Set and modify it
        return { selectedTasks: updatedMap };
      }),
    clearSelection: () => set({ selectedTasks: new Map() }),
    // getDistribution: () =>
    //   useTaskMultiSelectionStore.getState().selectedTasks.size > 0
    //     ? Array.from(useTaskMultiSelectionStore.getState().selectedTasks.values()).reduce(
    //         (acc, status) => {
    //           if (status === "active") acc.hasActiveTasks = true;
    //           if (status === "inactive") acc.hasInactiveTasks = true;
    //           return acc;
    //         },
    //         { hasActiveTasks: false, hasInactiveTasks: false }
    //       )
    //     : { hasActiveTasks: false, hasInactiveTasks: false },
  },
}));

export const useSelectionActions = () =>
  useTaskMultiSelectionStore((state) => state.actions);

export const useSelectedTasks = () =>
  useTaskMultiSelectionStore((state) => state.selectedTasks);

export const useIsTaskSelected = (taskId: string) =>
  useTaskMultiSelectionStore((state) => state.selectedTasks.has(taskId));

export const useNumberOfSelectedTasks = () =>
  useTaskMultiSelectionStore((state) => state.selectedTasks.size);

export const useGetDistribution = () =>
  useTaskMultiSelectionStore((state) => {
    const active = Array.from(state.selectedTasks.values()).filter(
      (status) => status === "active"
    ).length;
    const inactive = Array.from(state.selectedTasks.values()).filter(
      (status) => status === "inactive"
    ).length;
    return { active, inactive };
  });
